











































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { NumberLayer } from "@/model/document2/page/surface/design/layer/numberLayer"
import { TextInfo } from '@/utilityModels/textInfo';
import { MathHelper } from '@/helper/mathHelper';
import { FontManager } from '@/model/fontManager/fontManager';

import * as def from "@/definitions";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";
import RadioOn from "../resources/radioOn.vue";
import AlignLeftOn from "../resources/alignLeft_on.vue";
import AlignLeftOff from "../resources/alignLeft_off.vue";
import AlignCenterOn from "../resources/alignCenter_on.vue";
import AlignCenterOff from "../resources/alignCenter_off.vue";
import AlignRightOn from "../resources/alignRight_on.vue";
import AlignRightOff from "../resources/alignRight_off.vue";
import AlignEvenOn from "../resources/alignEven_on.vue";
import AlignEvenOff from "../resources/alignEven_off.vue";
import AlignTopOn from "../resources/alignTop_on.vue";
import AlignTopOff from "../resources/alignTop_off.vue";
import AlignMiddleOn from "../resources/alignMiddle_on.vue";
import AlignMiddleOff from "../resources/alignMiddle_off.vue";
import AlignBottomOn from "../resources/alignBottom_on.vue";
import AlignBottomOff from "../resources/alignBottom_off.vue";


@Component({
  components: {
    ValueEdit,

    ArrowDown,
    ArrowRight,
    CheckBoxOn,
    RadioOn,
    AlignLeftOn,
    AlignLeftOff,
    AlignCenterOn,
    AlignCenterOff,
    AlignRightOn,
    AlignRightOff,
    AlignEvenOn,
    AlignEvenOff,
    AlignTopOn,
    AlignTopOff,
    AlignMiddleOn,
    AlignMiddleOff,
    AlignBottomOn,
    AlignBottomOff
  }
})

// テキスト編集中かつ文字列非選択 / テキスト非選択中
// このとき、設定は文字列全てに反映する。
export default class NumberTextStyle extends Vue 
{
    @Prop() private layer!: NumberLayer;

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    // 開始番号
    private get format()
    {
        return this.layer.format;
    }

    private onSetFormat(value, isFinish)
    {
        var pattern = /^\d*$/;
        var reg = new RegExp(pattern);
        if(value == "" || reg.test(value))
        {
            // 文字が空か、すべて数字の場合のみ適用する
            this.changeLayerProperty(value, "format", isFinish);
        }

        if(isFinish)
        {
            // 強制的に表示更新
            var input = this.$refs.inputFormat as HTMLInputElement;
            input.value = this.layer.format;
        }
    }

    // 増減
    private get step()
    {
        return this.layer.step;
    }
    private onChangingValue(value, tag)
    {
        this.changeLayerProperty(value, tag, false);
    }
    private onChangedValue(value, tag)
    {
        this.changeLayerProperty(value, tag, true);
    }


    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //TODO Props
    openStatus = {
        opend: true
    };

    numberTextTransformContentsOpenAnimate = false;
    numberTextTransformContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.numberTextTransformContentsCloseAnimate = true;
        setTimeout(() => {
            this.numberTextTransformContentsCloseAnimate = false;
            this.numberTextTransformContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.numberTextTransformContentsOpenAnimate = true;
        setTimeout(() => {
            this.numberTextTransformContentsOpenAnimate = false;
        }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false) 
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    test(){
        alert("test")
    }

    private onFocusInput()
    {
        this.changeInputMode(1);
    }

    // 語頭・語尾
    private get prefix() 
    { 
        return this.layer.prefix; 
    }
    private onSetPrefix(value, isFinish)
    {
        if(isFinish)
        {
            this.changeInputMode(0);
        }
        else
        {
            this.changeInputMode(1);
        }
        this.changeLayerProperty(value, "prefix", isFinish);
    }
    private get suffix() 
    {
        return this.layer.suffix; 
    }
    private onSetSuffix(value, isFinish)
    {
        if(isFinish)
        {
            this.changeInputMode(0);
        }
        else
        {
            this.changeInputMode(1);
        }
        this.changeLayerProperty(value, "suffix", isFinish);
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }


    
}
